import type { EditAssetWorkflowOptions } from '../../types';

export const editContactWorkflow: EditAssetWorkflowOptions = {
  workflowKey: 'editContactWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'contact',
  workflowIndex: 2,
  workflowName: 'Edit',
  workflowActionIcon: 'EditOutlined',
  hideIfDisabled: true,
  workflowAssets: ['contact'],
  workflowStateTransformFunction: (assetPayload: any) => {
    const { email, description, contactName, phoneInfo, name, partnerProvidedId } = assetPayload;
    return {
      email,
      description,
      contactName,
      ...phoneInfo,
      name,
      partnerProvidedId,
    };
  },
  assetSchemaMatcher: {
    type: 'object',
    properties: {
      archived: { type: 'boolean', const: false },
      active: { type: 'boolean', const: true },
    },
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'email',
      workflowStepNavigationName: 'Contact Email',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        validationRegex:
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
        validationMessage: 'Invalid email address, please check the value provided.',
        prompt: 'What is the Contacts Email Address?',
        description: 'Add an Email address for the contact.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'email',
      },
    },
    {
      workflowStepKey: 'fullName',
      workflowStepNavigationName: 'Contact Full Name',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'What is the Contacts first and last name?',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'contactName',
      },
    },
    {
      workflowStepKey: 'phone',
      workflowStepNavigationName: 'Contact Phone',
      workflowComponent: {
        workflowComponentType: 'phoneNumberEntry',
        prompt: 'What is the Contacts Phone Number',
        description: '',
        help: '',
      },
      assetToWorkflowStateMapping: {
        assetProperties: ['phoneNumber', 'phoneNumberCountryCode'],
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'phoneInfo',
      },
    },
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Contact ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this contact',
        description: 'This is optional but will allow you to more easily reference this contact in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Contact Name',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'What will you call this contact',
        description:
          'Add a name for the contact to refer back to it.  You may have multiple contacts for the same person, this field can be used to disambiguate entries.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Contact Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 2,
        defaultValue: '',
        prompt: 'Enter a description (optional):',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this contact belong to a specific tenant?',
        description: '',
        help: 'Specifying a tenant will allow you to more easily filter you various configuration pieces',
        optional: true,
      },
      calculatedComponentProps: {
        assetId: {
          type: 'asset',
          property: 'contactId',
        },
      },
      optional: true,
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Contact Summary',
        description: 'The contact will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
